module.exports = require("core-js/modules/es.array.map.js");